import { useMemo } from "react";
import {
  COLORS,
  ICON_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { BuySellVolumeContainer } from "./style";

interface ITakerBuySellVolumeIndicatorProps {
  // Number between 0-1
  buyPercentage: number;
}

const MAX_BARS = 20;

function TakerBuySellVolumeIndicator({
  buyPercentage,
}: ITakerBuySellVolumeIndicatorProps) {
  // Clamp buy percentage to 0-1
  const buyPct = Math.min(Math.max(buyPercentage, 0), 1);
  const roundedBuyPercentage = Number((buyPct * 100).toFixed(0)) || 0;
  const roundedSellPercentage = 100 - roundedBuyPercentage;

  const isBuyDominant = roundedBuyPercentage >= roundedSellPercentage;

  const bars = useMemo(() => {
    const buyBarCount = 20 * (roundedBuyPercentage / 100);
    const sellBarCount = MAX_BARS - buyBarCount;

    const elems: JSX.Element[] = [];
    for (let i = 0; i < buyBarCount; i += 1) {
      elems.push(
        <div
          key={`buy${i}`}
          style={{
            backgroundColor: isBuyDominant
              ? COLORS.positive.one
              : ICON_COLORS.four,
          }}
        />
      );
    }
    for (let i = 0; i < sellBarCount; i += 1) {
      elems.push(
        <div
          key={`sell${i}`}
          style={{
            backgroundColor: isBuyDominant
              ? ICON_COLORS.four
              : COLORS.negative.one,
          }}
        />
      );
    }
    return elems;
  }, [isBuyDominant, roundedBuyPercentage]);

  return (
    <BuySellVolumeContainer>
      <span
        style={{
          color: isBuyDominant ? COLORS.positive.one : TEXT_COLORS.three,
        }}
      >
        {roundedBuyPercentage}% Buy
      </span>
      {bars}
      <span
        style={{
          color: isBuyDominant ? TEXT_COLORS.three : COLORS.negative.one,
        }}
      >
        {roundedSellPercentage}% Sell
      </span>
    </BuySellVolumeContainer>
  );
}

export default TakerBuySellVolumeIndicator;
